import React, { Fragment } from "react";
import { Container, Card, Row, Col} from "react-bootstrap";


const ProjectBasedLearning = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" style={{backgroundImage: 'url(/images/site/HandsOn.jpg)'}}>
        <h1 style={{color:'white'}}>Project Based Learning</h1>
      </div> 

      <Container fluid className="p-5">
        <Row>
         <p className="lead">Our Project Based Learning (PBL) modules are designed to provide a deeper learning experience, and build an innovation mindset. They come with detailed lesson plans for teachers.
        Our unique modules emphasize:
         </p>
         
            <ul>
                  <li>
                     <span><b> Minds-On Learning: </b></span> We encourage not just hands-on but also <em> minds-on </em> learning, with opportunities for students to engage both creatively and critically in every session.
                  </li>
                  <li>
                     <span><b> Improvisational Exercises: </b></span> Our classes often include improv games and exercises as warm-ups, which have been shown to improve creativity and spontaneity.
                  </li>
                  <li>
                     <span><b> STEAM Focused: </b></span> Most of our modules focus on STEM areas, so students acquire the top two 21st century skills (creativity + technology).
                  </li>

            </ul>
         
         </Row>
         <Row>
            <p className="lead">Below is a sampling of some of our modules.
            </p>
            <p style={{color: '#c87137'}}>
               <strong> Note: Our new modules, including those that build scientific creativity and reasoning, are coming online soon.  </strong>
            </p>

         
            <Card className="border-warning">
               <Row>
                  <Col className="col-12 col-md-3">
                     <img className="card-img-top img-fluid"
                        src="/images/challenges/How To Be An Inventor-small.png"
                        height="100%"
                        width = "100%"
                        alt="How To Be An Inventor"
                     />
                  </Col>
                  <Col className="col-12 col-md-9">
                     <Card.Body>
                        <Card.Title className="text-truncate">How To Be An Inventor</Card.Title>
                        <Card.Text className="small">       
                           In this module, students work on making their own product-based invention, starting from coming up with an idea all the way to prototyping and finalizing their invention. Students learn a few different creativity techniques like associative thinking and reverse thinking, which they use to come up with original ideas. In addition, they learn about design thinking, evaluating different ideas, pitching their idea and they even submit an application to a national level <a href="http://www.nmoe.org/students/siba.htm">invention competition</a>! The module ends with a demo day where the inventors show case their work and can include an audience voted best invention award.
                           <img className="card-img-top img-fluid"
                              src="/images/programs/InventorCampPicture.jpg"
                              height="100%"
                              width = "100%"
                              alt="How To Be An Inventor"
                           />
                        </Card.Text>
                        
                     </Card.Body>
                  </Col>
               </Row>   
            </Card>

            <Card className="border-warning">
               <Row>
                  <Col className="col-12 col-md-3">
                     <img className="card-img-top img-fluid"
                        src="/images/challenges/Programming an Interactive Play-small.png"
                        height="100%"
                        width = "100%"
                        alt="Programming an Interactive Play"
                     />
                  </Col>
                  <Col className="col-12 col-md-9">
                     <Card.Body>
                        <Card.Title className="text-truncate">Programming an Interactive Play</Card.Title>
                        <Card.Text className="small">       
                           This module extends the computer science unplugged concept into a bigger group project. In this highly collaborative group project students design an interactive play, where the audience gets some choice on how the play proceeds, while learning computer science fundamentals. The class is divided into three groups that work on the beginning, middle and end scenes of the story respectively. First, the three groups agree on the main characters and setting ("global variables"). Then each group uses creativity techniques like associative and analogical thinking in defining their scenes. Groups work independently and only communicate the least amount of information to the other teams. After all groups finish their scripts, the class puts the whole story together, invariably discovering hilarious "integration" issues!
                           <img className="img-fluid"
                              src="/images/programs/ProgrammingAPlayCampPicture.jpg"
                              height="100%"
                              width = "100%"
                              alt="How To Be An Inventor"
                           />
                        </Card.Text>
                        
                     </Card.Body>
                  </Col>
               </Row>   
            </Card>

            <Card className="border-warning">
               <Row>
                  <Col className="col-12 col-md-3">
                     <img className="img-fluid"
                        src="/images/challenges/Electronic Storybook-small.png"
                        height="100%"
                        width = "100%"
                        alt="Electronic Storybook"
                     />
                  </Col>
                  <Col className="col-12 col-md-9">
                     <Card.Body>
                        <Card.Title className="text-truncate">Electronic Storybook</Card.Title>
                        <Card.Text className="small">       
                           In this fun module students create their own storybooks that can light up! They learn about how electricity flows, circuits, switches and more. They even rig up their own circuit for their books using cell batteries and LED lights. Students incorporate creative thinking techniques as part of the story writing process and design their own illustrations on each page that gets enhanced with LED lights. The module ends with a story day where students read their story books to each other, and can even include an audience voted best author award.
                           <img className="img-fluid"
                              src="/images/programs/StorybookCampPicture.jpg"
                              height="100%"
                              width = "100%"
                              alt="Electronic Storybook"
                           />
                        </Card.Text>
                        
                     </Card.Body>
                  </Col>
               </Row>   
            </Card>

            <Card className="border-warning">
               <Row>
                  <Col className="col-12 col-md-3">
                     <img className="img-fluid"
                        src="/images/challenges/Imaginary Worlds-small.png"
                        height="100%"
                        width = "100%"
                        alt="Imaginary Worlds"
                     />
                  </Col>
                  <Col className="col-12 col-md-9">
                     <Card.Body>
                        <Card.Title className="text-truncate">Imaginary Worlds</Card.Title>
                        <Card.Text className="small">       
                           In this project, students create their their own fantasy world in real or imaginary settings. This multi-subject project based learning initiative covers different topics in science, history and social studies. With each session, students learn about a specific topic (e.g. social customs or laws) and use that knowledge, and their creativity, to refine their own world. In the process they build a deeper understanding and appreciation of the real world.
                           <img className="img-fluid"
                              src="/images/programs/ParacosmCampPicture.jpg"
                              height="100%"
                              width = "100%"
                              alt="Imaginary Worlds"
                           />
                        </Card.Text>
                        
                     </Card.Body>
                  </Col>
               </Row>   
            </Card>
         



        </Row>

      </Container>     

    </Fragment>
       
  );
};
  
export default ProjectBasedLearning;